
import { defineComponent } from "vue";
import { useI18n } from 'vue-i18n'
import { Grid } from "@progress/kendo-vue-grid";

export default defineComponent({
  name: "StatisticsTable",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  components: {
    "grid": Grid
  },
  props: {
    items: {
      type: Array,
    }
  },
  data() {
    return {
      columns: [
        {
          "field": "alert_name",
          "title": this.t("statistics.table.alert_name"),
        },
        {
          "field": "one_month",
          "title": this.t("statistics.table.1_month")
        },
        {
          "field": "six_months",
          "title": this.t("statistics.table.6_months")
        },
        {
          "field": "twelve_months",
          "title": this.t("statistics.table.12_months")
        },
        {
          "field": "all_time",
          "title": this.t("statistics.table.all_time")
        }
      ]
    }
  },
})
